export { default } from './BundlerLoaderProductInfo';
